import React from 'react'
import { letter } from '../../../QuestionsLearning/questionTypes'
import Tile, { ItemContent } from './Tile'
import styles from './answers.module.scss'

const stateOf = (item, isSelected, checked) => {
  if (!checked) return isSelected ? 'selected' : undefined
  if (isSelected) return item.isTrue ? 'correct' : 'wrong'
  return item.isTrue ? 'missed' : undefined
}

// type2: one or several correct options
function AnswerChoice({ question, draft, onChange, checked, order }) {
  const byId = Object.fromEntries((question.answers || []).map(_a => [_a._id, _a]))
  const toggle = (id) => onChange(draft.includes(id) ? draft.filter(_d => _d !== id) : [...draft, id])

  return (
    <div className={styles.stack} role="group">
      {order.map((id, index) => {
        const item = byId[id]
        if (!item) return null
        const isSelected = draft.includes(id)
        return (
          <Tile
            key={id}
            role="checkbox"
            aria-checked={isSelected}
            marker={letter(index)}
            state={stateOf(item, isSelected, checked)}
            disabled={checked}
            onClick={() => toggle(id)}
          >
            <ItemContent item={item} />
          </Tile>
        )
      })}
    </div>
  )
}

export default AnswerChoice
